import MyCourses from "./MyCourses.tsx";
export default MyCourses;
